import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections} from "components";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Access from "constants/Access";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Products / Firearms',
		url: '/products',
		icon: 'barcode',
	},
];

class Products extends Framework.Components.View {
	constructor(props) {
		super(props,' ');
	}

	handleSetTotal = (totalCount) => {
		this.setState({totalCount});
	}
	render() {
		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}>

					<div style={{display: 'flex', alignItems: 'center', width: '100%'}}>
						{this.state.totalCount > 0 && (
							<div style={{
								position: 'absolute',
								right: '50%',
								transform: 'translateX(50%)',
								color: '#666',
								fontSize: '0.9em',
								fontWeight: '500',
								pointerEvents: 'none',
								marginTop: '40px'
							}}>
								{this.state.totalCount + " total firearms"}
							</div>
						)}

					</div>
				</Framework.Components.PageBar>

				<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label="Products" value={' '}/>
					<Tab label="Pending" value="pending"/>
					{this.props.rootState.hasAmmoreadyModule && <Tab label="AmmoReady Products" value="ammoready_products"/>}
					{this.props.rootState.hasAmmoreadyModule && <Tab label="AmmoReady Orders" value="ammoready_orders"/>}
					{this.props.rootState.hasGunbrokerModule && <Tab label="GunBroker Products" value="foreign"/>}
					{this.props.rootState.hasGunbrokerModule && <Tab label="GunBroker Orders" value="gunbroker_orders"/>}
					{this.props.rootState.hasGunsAmericaModule && <Tab label="GunsAmerica Products" value="gunsamerica_products"/>}

				</Tabs>
				<div style={{display: this.state.tab === ' ' ? 'block' : 'none'}}>
					<Collections.Products
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						scannedCode={this.props.scannedCode}
						setTotalCount={this.handleSetTotal}
					/>
				</div>
				<div style={{display: this.state.tab === 'pending' ? 'block' : 'none'}}>
					<Collections.ProductsPending
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						scannedCode={this.props.scannedCode}
						setTotalCount={this.handleSetTotal}
					/>
				</div>
				<div style={{display: this.state.tab === 'ammoready_products' ? 'block' : 'none'}}>
					<Collections.ProductsAmmoready
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						scannedCode={this.props.scannedCode}
					/>
				</div>
				<div style={{display: this.state.tab === 'ammoready_orders' ? 'block' : 'none'}}>
					<Collections.OrdersAmmoready
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						scannedCode={this.props.scannedCode}
					/>
				</div>

				<div style={{display: this.state.tab === 'foreign' ? 'block' : 'none'}}>
					<Collections.ProductsForeign
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						scannedCode={this.props.scannedCode}
					/>
				</div>
				<div style={{display: this.state.tab === 'gunbroker_orders' ? 'block' : 'none'}}>
					<Collections.OrdersGunbroker
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						scannedCode={this.props.scannedCode}
					/>
				</div>

				<div style={{display: this.state.tab === 'gunsamerica_products' ? 'block' : 'none'}}>
					<Collections.ProductsGunsamerica
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						scannedCode={this.props.scannedCode}
					/>
				</div>
			</div>
		);
	}
}

export default Framework.Components.withRootState(Products);